import { defineStore } from "pinia";
import { HTTP } from "@/http";


import { useTracksStore } from "./tracks";
import { Howler } from "howler";
export const useAuthStore = defineStore("auth", {
    state: () => {
        return {
            isLoggedin: Boolean, // check user status 
            user: Object, // user data to be stored 
            token: "",
            isAuthenticatedUser: false,
            status: window.localStorage.getItem("status")

        }
    },// end of state
    getters: {
        getUser: (state) => state.user,
        isAuthenticated: (state) => state.isAuthenticatedUser,
        getPhone: (state) => state.user.phone,
        getStatus: (state) => state.status,
        getFavoriteTracks: (state) => state.favoriteTracks,
        getFavoritePlayLists: (state) => state.favoritePlaylists,
        getFolloings: (state) => state.followings,
        getPlaylists: (state) => state.playLists
       

    }, //end of getters 
    actions: {
        /**
         * 
         * subscribe 
         */
        async subscribeAction() {
           HTTP.get('/auth/sd/subscriptions/url')
               .then((response) => {
                
                window.location.href = response.data;
               })
               .catch((error) => {
                   console.error("Failed subscribe", error);
               });

        },

        /**
         * checking user subscribtion status
         */
        async checkSubescriptionStatus(phone) {
            // var phoneFormate= await this.phoneFormated(phone);
            return new Promise((resolve) => {
                HTTP.post(`/auth/sd/subscriptions/status/${phone}`).then(async response => (
                    this.user = response.data.user,
                    this.isAuthenticatedUser = response.data.status,

                    await this.setData(response)
                    , resolve(response)));

            })



        },


        async setData(response) {
            /**
             * @todo check for response code 101 == user subscribed but doesn't have active subscrbtion
             */

                   
            

                if (response.data.status) {

                    window.localStorage.setItem('user', JSON.stringify(response.data.user));
                    window.localStorage.setItem('token', response.data.token);
                    window.localStorage.setItem('status', response.data.status);
                    this.status = window.localStorage.getItem('status');

                } else {
                    this.wipeUserData(response)
                }

        
        },

        async unsubscribe() {
            let user = JSON.parse(localStorage.getItem('user'));
            if (user != null) {

                return new Promise((resolve) => {
                    HTTP.post(`/auth/sd/subscriptions/cancel/${user.phone}`)
                        .then((response) => {
                            this.wipeUserData(response)
                        })
                        .then(async response => {
                            this.wipeUserData(response),
                            resolve(response)
                        })
                });
            }
        },

       

        wipeUserData(response) {
            const player = useTracksStore();
           
            if (response.status) {
                window.localStorage.removeItem("user"),
                    window.localStorage.removeItem("token"),
                    window.localStorage.removeItem("status"),
                    this.status = localStorage.getItem("status") ? true : false
                     player.isPlaying = false,
                    Howler.stop()

            }
        },




        /**
         * logout the current authenticated user
         */
        async logOut() {
            const player = useTracksStore();

            await (window.localStorage.removeItem("user"),
                window.localStorage.removeItem("token"),
                window.localStorage.removeItem("status"),
                this.status = localStorage.getItem("status") ? true : false),
                player.isPlaying = false,
                Howler.stop()

        },



    }
})





